<template>
  <div class="drop-zone__container">
    <div v-show="undefined !== modelValue" class="drop-zone__files">
      <div v-for="file in modelValue" class="drop-zone__file">
        <img src="@/assets/icons/paper-clip.svg" alt="added file" />
        <span class="drop-zone__file-name">
          {{ file.name }}
        </span>
      </div>
    </div>
    <div v-if="undefined !== errors" class="drop-zone__error">
      <template v-for="error in errors">
        {{ error }}
      </template>
    </div>
    <label
      ref="dropZoneRef"
      class="drop-zone"
      :class="[{ over: isOverDropZone }, { error: undefined !== errors }]"
      for="downloadFile"
      title="Drag and Drop"
    >
      <img src="@/assets/icons/blue-folder.svg" alt="drop file" />
      <span class="drop-zone__caption">
        <span>{{ _T("@Attach image") }}</span>
        <span>
          {{ _T("@Maximum file size") }} {{ Math.trunc(maxSize / 1000000) }}Mb
        </span>
      </span>
    </label>
    <input
      id="downloadFile"
      class="drop-zone__input"
      type="file"
      :multiple="true"
      :accept="fileTypes.toString()"
      @click="clearUploadedFiles"
      @change="onFileChange"
    />
  </div>
</template>

<script setup>
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

const props = defineProps({
  name: { type: String, required: true },
  fileTypes: { Type: Array, required: true },
  maxSize: { Type: Number, required: true },
});

const modelValue = defineModel();
const dropZoneRef = ref(null);

const { errors: formErrors, validateField } = inject(FORM_INJECTION_KEY);
const errors = computed(() => {
  return formErrors?.value[props.name];
});

const onDrop = (files) => {
  modelValue.value = files;
  validateField(props.name);
};

const onFileChange = (event) => {
  modelValue.value = Array.from(event.target.files);
  validateField(props.name);
};

const clearUploadedFiles = () => {
  modelValue.value = undefined;
};

const { isOverDropZone } = useDropZone(dropZoneRef, {
  onDrop,
  dataTypes: props.fileTypes,
});
</script>

<style scoped lang="scss">
.drop-zone {
  width: 100%;

  @include flex-container(row, center, center);
  gap: 16px;

  border: 1px dashed var(--color-blue-base);
  border-radius: 16px;
  background-color: var(--color-sky-light);

  padding: 24px 8px;

  &.over {
    background-color: rgba(72, 167, 248, 0.2);
  }

  &.error {
    border-color: var(--color-red-error-500);
  }

  &__container {
    width: 100%;

    @include flex-container(column, flex-start, center);
    gap: 24px;
  }

  &__files {
    @include flex-container(row, flex-start, center);
    flex-wrap: wrap;
    gap: 8px;
  }

  &__file {
    @include flex-container(row, flex-start, center);
    gap: 8px;
  }

  &__input {
    display: none;
    opacity: 0;
    visibility: hidden;
  }

  &__caption {
    @include flex-container(column, flex-start, flex-start);
    gap: 8px;

    @include font(14, 16);
    color: var(--color-ink-lightest);

    span + span {
      @include font(12, 14);
    }
  }

  &__error {
    @include font(14, 16);

    color: var(--color-red-error-500);
  }
}
</style>
